export default __webpack_public_path__ + "static/media/CFO.1d0ea8ee.svg";